import { Grid, TextField, Typography } from "@mui/material";
import { AnswersProps } from "../../app/models/Answers";
import { useForm } from "react-hook-form";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  foodPhil: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  foodTeach: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const StatementFoodReflection: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const defaultValues = {
    foodPhil: answersData.find((answer) => answer.systemCodeId === 18)?.answer,
    foodTeach: answersData.find((answer) => answer.systemCodeId === 19)?.answer,
  };
  const {
    formState: { errors },
    register,
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderFoodHandlingReflectionCompetence = () => {
    return (
      <>
        <li>
          How do you partner with parents to promote proper food handling?
        </li>
        <li>
          What strategies do you use to engage parents in conversation regarding
          food handling and healthy habits?
        </li>
        <li>
          How do you schedule formal meetings with families on a consistent
          basis?
        </li>
        <li>
          How do you make families aware of informal meeting opportunities
          available?
        </li>
      </>
    );
  };

  const renderExamplePreparedFoodCompetence = () => {
    return (
      <>
        <li>
          How do you model proper food handling within the home environment?
        </li>
        <li>
          What resources do you provide families to build knowledge on healthy
          habits?
        </li>
      </>
    );
  };

  return (
    <Grid container sx={{ bgcolor: "#EBFCF2" }}>
      <Grid item xs={12} px={3} pt={3}>
        <Typography variant="body1" fontWeight="bold" paragraph>
          CS I-a &ndash; Food Handling Reflection
        </Typography>
        <Typography variant="body1">
          Think about what you have learned in your food handling training.
        </Typography>
      </Grid>
      <Grid item xs={12} pt={3} px={3}>
        <Typography variant="body1" paragraph>
          What is your philosophy about food handling?
        </Typography>
        <ReadMoreReadLess>
          <>{renderFoodHandlingReflectionCompetence()}</>
        </ReadMoreReadLess>
      </Grid>
      <Grid item xs={12} pt={3} px={3}>
        <TextField
          label="My philosophy about food handling is"
          multiline
          rows={2}
          fullWidth
          {...register("foodPhil")}
          name="foodPhil"
          sx={{ bgcolor: "#FFF" }}
          value={
            answersData.find((answer) => answer.systemCodeId === 18)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 18;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.foodPhil?.message}
          helperText={errors.foodPhil?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.foodPhil?.length}/500
        </Typography>
      </Grid>
      <Grid item xs={12} pt={3} px={3}>
        <Typography variant="body1" paragraph>
          What is an example of something you have taught families about food
          handling?
        </Typography>
        <ReadMoreReadLess>
          {renderExamplePreparedFoodCompetence()}
        </ReadMoreReadLess>
      </Grid>
      <Grid item xs={12} py={3} px={3}>
        <TextField
          label="An example of something I have taught families about food is"
          multiline
          rows={2}
          fullWidth
          {...register("foodTeach")}
          name="foodTeach"
          sx={{ bgcolor: "#FFF" }}
          value={
            answersData.find((answer) => answer.systemCodeId === 19)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 19;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.foodTeach?.message}
          helperText={errors.foodTeach?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.foodTeach?.length}/500
        </Typography>
      </Grid>
    </Grid>
  );
};
export default StatementFoodReflection;
